export default __webpack_public_path__ + "static/media/select-arrow-up.dde7d6ab.svg";